export const SUCCESS_LIGHT = "#DCFAE6";
export const SUCCESS_MAIN = "#17B26A";
export const SUCCESS_DARK = "#067647";

export const INFO_LIGHT = "#EFF4FF";
export const INFO_MAIN = "#2970FF";
export const INFO_DARK = "#00359E";

export const ERROR_LIGHT = "#FEE4E2";
export const ERROR_MAIN = "#F04438";
export const ERROR_DARK = "#B42318";

export const WARNING_LIGHT = "#FEF0C7";
export const WARNING_MAIN = "#F79009";
export const WARNING_DARK = "#B54708";
